import React from 'react';
import { useNavigate } from 'react-router-dom';
import GoBackArrow from '../../General/GoBackArrow';
import './liquidacionesModule.css';

export default function LiquidacionesPageHeader({
    title,
    subtitle,
    backTo,
    onBack,
    backLabel = 'Volver',
    showBack = false,
    actions,
    className = ''
}) {
    const navigate = useNavigate();
    const shouldShowBack = showBack || Boolean(backTo) || typeof onBack === 'function';

    const handleBack = () => {
        if (typeof onBack === 'function') {
            onBack();
            return;
        }

        if (backTo) {
            navigate(backTo);
        }
    };

    return (
        <div className={`row mb-3 mb-md-4 align-items-center liquidaciones-page-heading ${className}`.trim()}>
            {shouldShowBack && (
                <div className="col-auto liquidaciones-page-heading__back">
                    <GoBackArrow onBack={handleBack} label={backLabel} />
                </div>
            )}

            <div className={shouldShowBack ? 'col' : 'col-12 col-md-7'}>
                <h4 className="liquidaciones-page-heading__title text-themecolor color-rojo-megatone">
                    {title}
                </h4>
                {subtitle && (
                    <p className="liquidaciones-page-heading__subtitle mb-0">{subtitle}</p>
                )}
            </div>

            {actions && (
                <div className="col-12 col-md-5 text-md-end mt-2 mt-md-0">
                    {actions}
                </div>
            )}
        </div>
    );
}
